import Request from "../request";
const request = new Request();

export class NoticeService {
  static list = async (type: string, search: string, limit: any, offset: any) => {
    const res = await request.get(
      `board/article/list?type=${type}&offset=${offset}&limit=${limit}&search=${search}`
    );
    return res.data;
  };

  static create = async (data: {
    type: string;
    category?: string;
    title: string;
    content: string;
    isImportant?: string;
    password?: string;
  }) => {
    await request.post("board/article", data);
  };

  static view = async (idx: any) => {
    return await request.get("board/article/" + idx);
  };

  static update = async (
    data: { title: string; content: string; category?: string; isImportant?: string },
    idx: string
  ) => {
    await request.patch("board/article/" + idx, data);
  };

  static delete = async (idx: any) => {
    const res = await request.delete("board/article/" + idx);
    return res.data;
  };
}
